import { Component, EventEmitter, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthConfig, AuthService, ResponseObject } from "src/app/Services/auth.service";
import { StripeService } from "src/app/Services/stripe.service";
import { SubscriptionRulesService } from "src/app/Services/subscription-rules.service";
import { StripePlans } from "src/app/models/stripe.model";
import { SaveSubscriptionRulesRequest } from "src/app/models/subscriptionrules.model";

@Component({
    selector: 'stripe-payment-plan',
    templateUrl: './stripe-payment-plan.component.html',
    styleUrls: ['./stripe-payment-plan.component.css'],
    inputs: ['isStripePaymentPlansDialogVisible', 'stripeAllPlans'],
    outputs: ['onCloseStripePaymentPlanDailog'],
    standalone: false
})

export class StripePaymentPlanComponent implements OnInit {
    public isStripePaymentPlansDialogVisible!: boolean;
    public onCloseStripePaymentPlanDailog = new EventEmitter<boolean>();
    public isArtist: boolean = false;
    public isGallery: boolean = false;
    public isFreePlanUser: boolean = true;
    public authConfig!: AuthConfig;
    public isAuthenticated!: boolean;
    public stripeAllPlans: StripePlans[] = [];
    public isOnFreeTrial!: boolean;
    public activeSubscriptionRule!: SaveSubscriptionRulesRequest;

    constructor(private authService: AuthService,
        private ngxSpinnerService: NgxSpinnerService,
        private stripeService: StripeService,
        private subscriptionRulesService: SubscriptionRulesService,
    ) {

    }
    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        this.isAuthenticated = this.authService.isAuthenticated();

        if (this.isAuthenticated) {
            this.authConfig = this.authService.getAuthConfig();
            this.isArtist = this.authConfig.IsArtist || false;
            this.isGallery = this.authConfig.IsGallery || false;
            this.isFreePlanUser = this.authService.isFreePlanUser();
            this.isOnFreeTrial = this.authService.isOnFreetrial();
            if(this.isStripePaymentPlansDialogVisible == true){
                this.getAllPlans();
            }
        }

    }

    public getAllPlans() {
        if (this.isArtist || this.isGallery) {
          if (this.isFreePlanUser || this.isOnFreeTrial) {
            this.ngxSpinnerService.show();
            this.stripeService.getAllPlans().subscribe((ApiResponce: StripePlans[]) => {
                console.log(ApiResponce);
                this.stripeAllPlans = ApiResponce;
                console.log(this.stripeAllPlans);
                this.getActiveSubscriptionRule();

                this.ngxSpinnerService.hide();
              },
              (error) => { console.error(error); this.ngxSpinnerService.hide(); }
            );
          }
        }
    }

    public closeStripePaymentDialog() {
        this.isStripePaymentPlansDialogVisible = false;
        this.onCloseStripePaymentPlanDailog.emit(this.isStripePaymentPlansDialogVisible)
    }

    public upgradeAccount(stripePro: StripePlans) {
        this.ngxSpinnerService.show();
        this.stripeService.upgradeAccountPro(stripePro.PlanId, stripePro.Currency).subscribe((response: ResponseObject) => {
            console.log(response.Success)
            if (response.Success) {
                window.location.href = response.ResponseData;
            }
            this.ngxSpinnerService.hide();
        }, error => { console.error(error); this.ngxSpinnerService.hide(); });
    }

  public getActiveSubscriptionRule() {
        this.subscriptionRulesService.getActiveSubscriptionRules().subscribe((ActiveSubscriptionRule: SaveSubscriptionRulesRequest) => {
            this.activeSubscriptionRule = ActiveSubscriptionRule
            console.log(this.activeSubscriptionRule);
        }, (error) => { console.error('Error while fetching Active subscription rules data', error); this.ngxSpinnerService.hide(); })
    }


}